import { jsx as C } from "react/jsx-runtime";
function t(r) {
  return /* @__PURE__ */ C(
    "svg",
    {
      width: "17",
      height: "17",
      viewBox: "0 0 17 17",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: /* @__PURE__ */ C("path", { d: "M12.2915 1.16686C12.1045 0.97886 11.8505 0.872824 11.5853 0.872074C11.3202 0.871324 11.0656 0.975921 10.8775 1.16286C10.7783 1.264 10.7016 1.38498 10.6525 1.51786C9.8205 3.25386 8.9045 4.23286 7.7485 4.81086C6.4515 5.45086 4.9625 5.89586 2.5625 5.89586C2.36508 5.8968 2.1723 5.95579 2.00818 6.06551C1.84405 6.17522 1.71584 6.3308 1.6395 6.51286C1.56393 6.69566 1.54421 6.89675 1.58283 7.09074C1.62145 7.28474 1.71668 7.46295 1.8565 7.60286L5.0995 10.8459L0.5625 16.8959L6.6125 12.3589L9.8545 15.6009C9.94737 15.6945 10.0583 15.7683 10.1805 15.8179C10.3025 15.8689 10.4325 15.8959 10.5625 15.8959C10.6925 15.8959 10.8225 15.8689 10.9445 15.8179C11.1274 15.7428 11.2838 15.6151 11.3938 15.4509C11.5039 15.2867 11.5626 15.0935 11.5625 14.8959C11.5625 12.4959 12.0065 11.0069 12.6455 9.72986C13.2225 8.57386 14.2015 7.65786 15.9385 6.82586C16.0713 6.77721 16.1921 6.70046 16.2925 6.60086C16.4794 6.41281 16.584 6.1582 16.5833 5.89303C16.5825 5.62787 16.4765 5.37386 16.2885 5.18686L12.2915 1.16686Z" })
    }
  );
}
export {
  t as PinIcon
};
